import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";
import { Tooltip } from "primereact/tooltip";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SavedCDEIcon from "../../assests/save.svg";
import IconInputText from "../../component/iconInputText/iconInputText";
import { LabelHeading } from "../../component/LabelHeader/labelHeader.style";
import TableComponent from "../../component/Tables/tableComponent";
import { getdataAssetProfile, getSelectedCDE, ruleRecommendation, submitRuleRecommendation } from "../../redux/dataAsset/dataAsset.action";
import { SET_FORM_OPTION, SET_FORM_VALUE } from "../../redux/dataAsset/dataAsset.type";
import { theme } from "../../theme/theme";
import { Container } from "../global/global.style";
import RecommendationPopUp from "./recommendationPopUp";
import SelectedCdePopUp from "./selectedCdePopUp";
import { Toast } from "primereact/toast";
import { rolePermissionMapping } from "../../data/userAccess/userRoleMapping"
import { checkButtonDisabledStatus } from "../../helpers/validation/userValidation"
import { useMemo } from "react"


function ProfileCde({ changeDetail, dataAssetId }) {
    const { apiData, formData } = useSelector((state) => state.dataAsset);
    const [searchVal, setSearchVal] = useState("");
    const [cdeEnable, setCdeEnable] = useState(false);
    const [enableRecommendation, setEnableRecommendation] = useState(false);
    // State to manage pagination
    const [pagination, setPagination] = useState({
        first: 0,   // index of the first record
        rows: 15,    // number of rows per page
    });

    const dispatch = useDispatch();
    const toast = useRef(null);

    // Handle page change
    const handlePageChange = (e) => {
        setPagination({
            first: e.first,   // new first record index
            rows: e.rows,     // new number of rows per page
        });
    };

    useEffect(() => {
        let dataAssetId = formData.selectedProfile?.data_asset_id;
        if (dataAssetId) {
            dispatch(getdataAssetProfile(dataAssetId));
        }
    }, [formData.selectedProfile, dispatch]);

    useEffect(() => {
    }, [])
    const show = (status, message) => {
        if (status === undefined) {
            toast.current.show({
                severity: apiData.recommendateRule.status === "success" ? "success" : apiData.recommendateRule.status === "fail" ? "error" : 'info', summary: apiData.recommendateRule.status, detail: apiData.recommendateRule.data.message
            });

        } else {
            toast.current.show({
                severity: status === "success" ? "success" : status === "fail" ? "error" : 'info', summary: status, detail: message
            });
        }

    }
    const showLoadingMessage = () => {
        toast.current.show({
            severity: 'info', summary: "Note", detail: "Please be patient; the rule suggestion process may take 5-6 minutes to complete"
            // apiData.newDataAssest.data 
        });
    };
    const getRuleRecommendationLabel = () => {
        return <span> <span>Suggest Rules</span> {apiData.recommendateRule.loading ? <ProgressSpinner style={{ width: '25px', height: '25px' }} /> : ""}</span>
    }
    const getTableColumns = () => {
        return [
             { header: "#", body: (data, options) => options.rowIndex + 1 },
            { field: "attribute_name",
          sortField: "attribute_name", sortable: true, header: "Column Name" },
            { field: "attribute_details.statistics.data_type", header: "Data Type" },
            { field: "attribute_details.statistics.min", header: "Min" },
            { field: "attribute_details.statistics.max", header: "Max" },
            { field: "attribute_details.statistics.mean", header: "Mean" },
            { field: "attribute_details.statistics.std_dev", header: "Standard Deviation" },
            { field: "attribute_details.statistics.null_percentage", header: "Null Percentage" },
            { field: "attribute_details.statistics.unique_count", header: "Distinct Count" },
            { field: "attribute_details.statistics.total_count", header: "Total Count" },
            // { field: "dec_str_bool_int_count", header: "Dec Str Bool Int Count" },
            // { field: "distribution", header: "Distribution",body:<UnderlineGlobalValue>View Graph</UnderlineGlobalValue> }
        ];
    };

    const ruleRecommendationClicked = () => {
        if (formData.selectedProfile.options.length === 0) {
            dispatch(ruleRecommendation(dataAssetId))
            setEnableRecommendation(true);
        } else {
            dispatch(submitRuleRecommendation(dataAssetId, showLoadingMessage, show));

            // setEnableRecommendation(true);
        }
    };
    const getTotalProfileData = () => {
        if (searchVal === "") {
            return apiData.profileCde.data
        } else {
            return apiData.profileCde.data.filter((val) => val.attribute_name.toLowerCase().includes(searchVal.toLowerCase()));
        }
    };
    const getProfileData = () => {
        if (searchVal === "") {
            return apiData.profileCde.data.slice(pagination.first, pagination.first + pagination.rows);
        } else {
            return apiData.profileCde.data.filter((val) => val.attribute_name.toLowerCase().includes(searchVal.toLowerCase())).slice(pagination.first, pagination.first + pagination.rows);
        }
    };

            
             const access = apiData?.assetSummary?.data?.access || [];  
             const role = access?.[0]?.role_permission_id; 
            const isDisabledAction = useMemo(() => {
                return role
                  ? checkButtonDisabledStatus(
                      access,
                      role,
                      "Profile/CDE",
                      rolePermissionMapping?.[role]?.buttons || {}
                    )
                  : true;
              }, [role, access, rolePermissionMapping]);

    return (
        <Fragment>

            {
                // apiData.profileCde.loading || apiData.recommendateRule.loading ? (
                //     <div style={{ width: "100%", textAlign: "center", lineHeight: window.innerHeight + "px", verticalAlign: "middle" }}>
                //         <ProgressSpinner />
                //     </div>
                // ) : 
                (
                    <Container style={{ height: "90%" }}>
                        <div className="grid">
                            <div className="col-5">
                                <LabelHeading>
                                    Profile & CDE Selection <Tooltip style={{ fontSize: "10px" }} mouseTrack target=".iconprofileInfo" />
                                    <i
                                        style={{ marginLeft: "10px" }}
                                        className="pi pi-info-circle iconprofileInfo"
                                        data-pr-tooltip="Profile data and select Critical Data Elements (CDEs) to configure and implement data quality rules effectively."
                                    />
                                </LabelHeading>
                            </div>
                            <div className="col-7" style={{ textAlign: "right" }}>
                                <div style={{ width: "300px", display: "inline-block", marginRight: "5px" }}>
                                    <IconInputText
                                        iconPosition="right"
                                        style={{ width: "100%", height: "40px" }}
                                        value={searchVal}
                                        onChange={(e) => {
                                            setSearchVal(e.target.value);
                                        }}
                                        iconName="pi-search"
                                        placeholderName="Search Column"
                                    />
                                </div>
                                {/* <Button
                                    outlined
                                    style={{ color: theme.colors.primary, marginRight: "5px"  }}
                                    onClick={() => {
                                        dispatch(getSelectedCDE(dataAssetId))
                                        setCdeEnable(true);
                                    }}
                                    label={
                                        <Fragment>
                                            <span style={{ verticalAlign: "super", marginRight: "5px" }}>Show Saved CDEs</span>
                                            <img src={SavedCDEIcon} />
                                        </Fragment>
                                    }
                                /> */}
                                <Button
                                    outlined
                                    style={{ display: "inline-grid", width: "150px", marginRight: "5px", color: theme.colors.marsOrange, padding: apiData.recommendateRule.loading ? "2px" : "unset" }}
                                    onClick={() => {
                                        ruleRecommendationClicked();
                                    }}
                                    // disabled={(apiData.recommendateRule.data.length === 0 && formData.selectedProfile.options === 0) | apiData.assetSummary.data.access.length === 0 && (apiData.assetSummary.data.created_by !== localStorage.getItem("userName") && !apiData.assetSummary.data.access[0]?.permission_description.includes("Configure Rules")) || apiData.recommendateRule.loading}
                                    disabled={(apiData.recommendateRule.data.length === 0 && formData.selectedProfile.options === 0) || isDisabledAction || apiData.recommendateRule.loading}
                                    label={getRuleRecommendationLabel()}
                                />
                                <Button style={{ width: "43px", height: "40px" }} icon="pi pi-refresh" onClick={() => { dispatch(getdataAssetProfile(dataAssetId)) }} outlined />
                            </div>
                        </div>
                        <div className="grid" style={{ height: "90%" }}>
                            <div className="col-12" style={{ height: "100%" }}>
                                <TableComponent
                                    checkboxDisabled={isDisabledAction}
                                    paginator
                                    rows={pagination.rows}
                                    first={pagination.first}
                                    totalRecords={getTotalProfileData().length}
                                    onPage={handlePageChange}  // Handle page change
                                    rowsPerPageOptions={[15, 30, 45]}  // Options to change rows per page
                                    scrollable
                                    scrollHeight="100%"
                                    className="tableFullheight"
                                    selection={formData.selectedProfile.options}
                                    onSelectionChange={(e) => {
                                    
                                        if (e.type === "all") {
                                            if (e.value.length > 0) {
                                                dispatch({
                                                    type: SET_FORM_OPTION,
                                                    payload: {
                                                        formField: "selectedProfile",
                                                        data: getTotalProfileData(),
                                                    },
                                                });
                                            } else {
                                                dispatch({
                                                    type: SET_FORM_OPTION,
                                                    payload: {
                                                        formField: "selectedProfile",
                                                        data: []
                                                    },
                                                });
                                            }
                                        } else {
                                            dispatch({
                                                type: SET_FORM_OPTION,
                                                payload: {
                                                    formField: "selectedProfile",
                                                    data: e.value,
                                                },
                                            });
                                            if (e.value.length > 0) {
                                                dispatch({
                                                    type: SET_FORM_VALUE,
                                                    payload: {
                                                        formField: "selectedProfile",
                                                        value: e.value[0].data_asset_id,
                                                    },
                                                });
                                            }
                                        }
                                    }}
                                    tableData={getProfileData()}
                                    columns={getTableColumns()}
                                    removableSort 
                                    // virtualScroll  // Use virtual scrolling
                                    // lazy           // Enable lazy loading
                                    checked={true}
                                />
                            </div>
                        </div>
                        {/* <div className="grid" style={{ marginTop: "20px", textAlign: "right" }}>
                            <div className="col-12">
                                <Button onClick={() => { }} label="Next" icon="pi pi-arrow-right" iconPos="right" />
                            </div>
                        </div> */}
                        <Toast ref={toast} />
                        {cdeEnable ? <SelectedCdePopUp changeDetail={changeDetail} dataAssetId={dataAssetId} onHide={() => { setCdeEnable(false); }} /> : ""}

                        {enableRecommendation ? <RecommendationPopUp chan dataAssetId={dataAssetId} onHide={() => { setEnableRecommendation(false); }} /> : ""}
                    </Container >
                )
            }
        </Fragment >
    );
}

export default ProfileCde;